export const timeDecimalString = (data): string =>
  `${data?.averageDeliveryDays}.${
    data.averageDeliveryHours ? Math.floor((data.averageDeliveryHours / 24) * 10) : 0
  }`;
